import {StringUtil} from '@shared/util/string.util';
import {ActivityDTO, ActivityState} from '@domain/activity/activity.dto';
import {ActivityScheduleUtil} from '@domain/activity/schedule/activity-schedule.util';

export class ActivityUtil {

  public static getSlug(activity: ActivityDTO | null): string | null {
    if (!activity?.id) {
      return null;
    }
    const data: string[] = [];
    const title = activity.title;
    if (title) {
      data.push(title);
    }
    let str = StringUtil.slugify(data.join(StringUtil.SLUG_SPACER)) ?? '';
    if (str.length > 0) {
      str += StringUtil.SLUG_SEPARATOR;
    }
    str += activity.id;
    return str;
  }

  public static getImproveMessages(activity: ActivityDTO | null): string[] {
    if (!activity || ![ActivityState.Draft, ActivityState.Submitted, ActivityState.Published].includes(activity?.state)) {
      return [];
    }
    const msgs: string[] = [];
    if ((activity?.schedules ?? []).length === 0) {
      msgs.push("Cette activité n'a pas encore de planification et ne sera pas visible.");
    } else {
      const activeSchedules = ActivityScheduleUtil.getActiveSchedules(activity?.schedules ?? []);
      if (activeSchedules.length === 0) {
        msgs.push("Cette activité n'a pas de planification valable et ne sera pas visible.");
      } else {
        const hasImprovableSchedules = activeSchedules.filter(s => ActivityScheduleUtil.getImproveMessages(s).length > 0).length > 0;
        if (hasImprovableSchedules) {
          msgs.push("Certaines planifications peuvent être améliorées.");
        }
      }
    }

    if (activity?.description === null) {
      msgs.push("Cette activité n'a pas de description.");
    }

    if (!activity?.cover) {
      msgs.push("Cette activité n'a pas d'image d'illustration.");
    }

    return msgs;
  }

  public static hasLinks(activity: ActivityDTO | null): boolean {
    return !!(activity?.webUrl || activity?.fbUrl || activity?.igUrl);
  }

}
